import React, {useState} from 'react';
import { Box, Typography, IconButton, Button } from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";
import DQProgramConfirmation from "./DQProgConfirmation.comp";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    editIcon: {

    },
}));

const DQProgramSummary = ({ responses, onEdit, }) => {
    const classes = useStyles();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const getResponse = (id) => responses[id] || 'Not specified';
    const getArrayResponse = (id) => Array.isArray(responses[id]) ? responses[id].join(", ") : 'None';
    const getNestedResponse = (id, field) => responses[id]?.[field] || 'Not specified';

    if (showConfirmation) {
        return <DQProgramConfirmation />;
    }


    return (
        <Box sx={{ p: 3, maxWidth: 1200, }}>
            {/* Country Context */}
            <Section title="Country Context" onEdit={() => onEdit(5)}>
                <Typography>Your target country/region is: <b style={{ color: '#018FA6' }}>{getResponse(5)?.country}</b></Typography>
                <Typography mt={1}>We will align your program with the relevant national and international frameworks:</Typography>
                <ul style={{ marginTop: 4, paddingLeft: 20 }}>
                    <li>IEEE</li>
                    <li>UNESCO</li>
                </ul>
            </Section>

            {/* Learner Age Group */}
            <Section title="Learner Age Group" onEdit={() => onEdit(4)}>
                <Typography>Your target age group is: <b style={{ color: '#018FA6' }}>{getResponse(4)?.targetAudAge}</b></Typography>
            </Section>

            {/* Learning Themes */}
            <Section title="Learning Themes & Competencies" onEdit={() => onEdit(1)}>
                <Typography mt={1}>You are developing an Al Literacy program with the following:</Typography>
                <Typography>Theme: <b style={{ color: '#018FA6' }}>{getResponse(2) || getResponse(1) || 'Not specified'}</b></Typography>
                <Typography mt={1}>Competencies: <b style={{ color: '#018FA6' }}>{getArrayResponse(1)}</b></Typography>
            </Section>

            {/* Learning Focus */}
            <Section title="Learning Focus Areas" onEdit={() => onEdit(12)}>
                <Typography>Primary focus: <b style={{ color: '#018FA6' }}>{getNestedResponse(12, 'understanding_problems')}</b></Typography>
                <Typography mt={1}>Knowledge emphasis: <b style={{ color: '#018FA6' }}>{getNestedResponse(13, 'raising_awareness')}</b></Typography>
                <Typography mt={1}>Mindset emphasis: <b style={{ color: '#018FA6' }}>{getNestedResponse(14, 'positive_attitudes')}</b></Typography>
            </Section>

            {/* Learning Context */}
            <Section title="Learning Context" onEdit={() => onEdit(15)}>
                <Typography>Learner's prior exposure: <b style={{ color: '#018FA6' }}>{getResponse(15)}</b></Typography>
                {getResponse(16) && (
                    <Typography mt={1}>Details: <b style={{ color: '#018FA6' }}>{getResponse(16)}</b></Typography>
                )}
                <Typography mt={1}>Cultural considerations: <b style={{ color: '#018FA6' }}>{getArrayResponse(21)}</b></Typography>
                {getResponse(22) && (
                    <Typography mt={1}>Sensitivity details: <b style={{ color: '#018FA6' }}>{getResponse(22)}</b></Typography>
                )}
            </Section>

            {/* Curriculum */}
            <Section title="Curriculum Type" onEdit={() => onEdit(6)}>
                <Typography>Implementation: <b style={{ color: '#018FA6' }}>{getResponse(6)}</b></Typography>
                {getResponse(7)?.subject && (
                    <Typography mt={1}>Your AI Literacy program will be integrated into existing subject areas, specifically: <b style={{ color: '#018FA6' }}>{getResponse(7).subject}</b></Typography>
                )}
                {getResponse(8) && (
                    <Typography mt={1}>Learning topic: <b style={{ color: '#018FA6' }}>{getResponse(8)}</b></Typography>
                )}
            </Section>

            {/* Buttons */}
            <Box sx={{ width:'50%',margin:'0 auto',display: 'flex', justifyContent: 'space-between', mt: 4 }}>
                <Button
                    variant="outlined"
                    sx={{
                        color: '#018FA6',
                        borderColor: '#018FA6',
                        borderRadius: '15px',
                        px: 4,
                        py: 1,
                        '&:hover': {
                            borderColor: '#018FA6',
                            backgroundColor: 'rgba(1, 143, 166, 0.04)'
                        }
                    }}
                >
                    Start Over
                </Button>
                <Button
                    variant="contained"
                    onClick={() => setShowConfirmation(true)}
                    sx={{
                        backgroundColor: '#FE686F',
                        color: 'white',
                        borderRadius: '15px',
                        px: 4,
                        py: 1,
                        '&:hover': {
                            backgroundColor: '#FE686F',
                            opacity: 0.9
                        }
                    }}
                >
                    Proceed
                </Button>
            </Box>
        </Box>
    );
};

const Section = ({ title, children, onEdit }) => (
    <Box mb={3} sx={{ p: 3, borderRadius: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography variant="h6" fontWeight="bold" color="black">
                {title}
            </Typography>
            <IconButton
                size="small"
                onClick={onEdit}
                sx={{ color: 'text.secondary' }}
            >
                <EditIcon fontSize="small" style={{cursor: 'pointer', color: '#EE6628 !important',}}/>
            </IconButton>
        </Box>
        <Box sx={{ pl: 1 }}>
            {children}
        </Box>
    </Box>
);

export default DQProgramSummary;